export default __webpack_public_path__ + "static/media/sunset-sherbert-pink.8c3fd8b4.png";